import { Component, OnInit, HostBinding } from '@angular/core';
import '@progress/kendo-date-math/tz/Europe/Paris';
import { AccountConfigService } from '../../services/account-config/account-config.service';
import { MStaticClient, MStaticInter } from '@argalis-apps/models';
import { SchedulerEvent } from '@progress/kendo-angular-scheduler';

@Component({
  selector: 'ags-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  public idSP: number;
  public idIndispo: number;
  public dateClicked: any;
  staticRequest: MStaticClient.IStaticClientRequest | MStaticInter.IStaticInterRequest = {} as
    | MStaticClient.IStaticClientRequest
    | MStaticInter.IStaticInterRequest;
  constructor(private accountConfigService: AccountConfigService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }

  getDateClicked(event: SchedulerEvent) {
    if (event) {
      if (event['statut'] !== 'INDISPONIBLE') {
        this.idSP = event.id;
        this.idIndispo = void 0;
      } else {
        this.idSP = void 0;
        this.idIndispo = event.id;
      }
      this.dateClicked = new Date(event.start);
    }
  }
}
